export default __webpack_public_path__ + "static/media/CXP-logo.37fe1ee7.svg";